<form [formGroup]="form" *ngIf="{facets: facets$ | async} as data" class="side-bar vision-dark-theme">
  <div class="side-bar-header action">
    <!-- TODO behavior should be to go back to before search -->
    <a [routerLink]="lastNonSearchUrl">
      <div class="action-title">
        <fw-icon color="primary" size="small">arrow-back</fw-icon>
        <span>{{'sidebar.search.header' | translate}}</span>
      </div>
    </a>
  </div>
  <div class="side-bar-body" cdkScrollable>
    <div class="side-bar-body-item search">
      <fw-text-input *ngIf="!isAdvancedSearchMode && !isAdvancedQuery" size="small" class="side-bar-body-item-input" formControlName="searchTerm"
        [leftIcon]="'search'" [placeholder]="'sidebar.search.body.search.title' | translate"></fw-text-input>
      <a class="side-bar-body-item-offset" *ngIf="!isAdvancedSearchMode && !isAdvancedQuery" routerLink="search/advanced">
        <fw-button type="button" [fullWidth]="true" size="small" variant="outline" leftIcon="settings-adjust">
          {{'sidebar.search.body.search.advancedSearch' | translate}}
        </fw-button>
      </a>
      <a class="side-bar-body-item-offset" *ngIf="isAdvancedSearchMode && !isAdvancedQuery" routerLink="search/advanced">
        <fw-button type="button" [fullWidth]="true" size="small" variant="outline" leftIcon="edit">
          {{'sidebar.search.body.search.editQuery' | translate}}
        </fw-button>
      </a>
      <a class="side-bar-body-item-offset" *ngIf="isAdvancedSearchMode || isAdvancedQuery" routerLink="search">
        <fw-button (click)="onBaseSearchClick()" type="button" [fullWidth]="true" size="small" variant="outline"
          leftIcon="window-resize-right">
          {{'sidebar.search.body.search.basicSearch' | translate}}
        </fw-button>
      </a>
    </div>
    <div class="side-bar-body-item project">
      <span class="side-bar-body-item-offset side-bar-body-item-title">
        {{'sidebar.search.body.project.title' | translate}}
      </span>
      <div *ngIf="{projectsGroups: projectsGroups$ | async} as data" class="side-bar-body-item-input select" fwMenuCloseTriggers>
        <fw-text-input [cdkMenuTriggerFor]="selectProjectMenu"
          [leftIcon]="selectedProjectFilter ? 'folder-open' : null"
          [rightIcon]="selectedProjectFilter ? 'close-circled' : 'chevron-down'"
          (rightIconAction)="resetProjectFilter()"
          [useActionableIcons]="true"
          [placeholder]="selectedProjectFilter ? selectedProjectFilter.label : ('sidebar.search.body.project.placeholder' | translate)"
          size="small"
          [readOnly]="true">
        </fw-text-input>
        <ng-template #selectProjectMenu>
          <fw-menu-container maxHeight="500px" width="275px">
            <fw-menu-item-group *ngFor="let projectGroup of data.projectsGroups" [title]="projectGroup.title">
              <fw-menu-item *ngFor="let item of projectGroup.options" icon="folder-open" [title]="item.label"
                (click)="selectProjectFilter(item)"
                [value]="item.value" size="compact"></fw-menu-item>
            </fw-menu-item-group>
          </fw-menu-container>
        </ng-template>
        <ng-template #empty>
          <fw-select optionsWidth="200px" width="100%" size='small'
            [placeholder]="'sidebar.search.body.project.placeholder' | translate">
            <fw-menu-item [title]="'sidebar.search.body.project.empty' | translate" [value]="''"></fw-menu-item>
          </fw-select>
        </ng-template>
      </div>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block [title]="'sidebar.search.body.fileType.title' | translate">
        <div *ngIf="fileTypeControls.length" class="side-bar-body-item-checkboxes">
          <div [formArrayName]="controlsEnum.FileType">
            <div *ngFor="let bucket of fileTypeControls; let i = index" [formGroupName]="i"
              class="side-bar-body-item-checkboxes-item" [title]="bucket.get('key').value">
              <mat-checkbox formControlName="selected"><span
                  class="side-bar-body-item-checkboxes-item-title">{{bucket.get('key').value}}</span></mat-checkbox>
              <span>{{bucket.get('doc_count').value}}</span>
            </div>
          </div>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block [title]="'sidebar.search.body.modality.title' | translate">
        <div *ngIf="modalityControls.length" class="side-bar-body-item-checkboxes">
          <div [formArrayName]="controlsEnum.Modality">
            <div *ngFor="let bucket of modalityControls; let i = index" [formGroupName]="i"
              class="side-bar-body-item-checkboxes-item" [title]="bucket.get('key').value">
              <mat-checkbox formControlName="selected"><span
                  class="side-bar-body-item-checkboxes-item-title">{{bucket.get('key').value}}</span></mat-checkbox>
              <span>{{bucket.get('doc_count').value}}</span>
            </div>
          </div>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block [title]="'sidebar.search.body.classification.title' | translate">
        <div *ngIf="classificationControls.length" class="side-bar-body-item-checkboxes">
          <div [formArrayName]="controlsEnum.Classification">
            <div *ngFor="let bucket of classificationControls; let i = index" [formGroupName]="i"
              class="side-bar-body-item-checkboxes-item" [title]="bucket.get('key').value">
              <mat-checkbox formControlName="selected"><span
                  class="side-bar-body-item-checkboxes-item-title">{{bucket.get('key').value}}</span></mat-checkbox>
              <span>{{bucket.get('doc_count').value}}</span>
            </div>
          </div>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block [title]="'sidebar.search.body.sessionTimestamp.title' | translate">
        <div class="side-bar-body-item-session-range">
          <fw-date-input size="small" [formControlName]="controlsEnum.From" class="side-bar-body-item-input"
            type="date"></fw-date-input>
          <fw-date-input size="small" [formControlName]="controlsEnum.To" class="side-bar-body-item-input"
            type="date"></fw-date-input>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block [title]="'sidebar.search.body.sex.title' | translate">
        <div *ngIf="sexControls.length" class="side-bar-body-item-checkboxes">
          <div [formArrayName]="controlsEnum.Sex">
            <div *ngFor="let bucket of sexControls; let i = index" [formGroupName]="i"
              class="side-bar-body-item-checkboxes-item">
              <mat-checkbox formControlName="selected"><span
                  class="side-bar-body-item-checkboxes-item-title">{{bucket.get('key').value}}</span></mat-checkbox>
              <span>{{bucket.get('doc_count').value}}</span>
            </div>
          </div>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block [title]="'sidebar.search.body.subjectAge.title' | translate">
        <div class="side-bar-body-item-session-range">
          <fw-text-input size="small" [formControlName]="controlsEnum.SubjectAgeFrom" class="side-bar-body-item-input"
            [placeholder]="'sidebar.search.body.subjectAge.minAge' | translate"></fw-text-input>
          <fw-text-input size="small" [formControlName]="controlsEnum.SubjectAgeTo" class="side-bar-body-item-input"
            [placeholder]="'sidebar.search.body.subjectAge.maxAge' | translate"></fw-text-input>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
    <div class="side-bar-body-item">
      <app-side-bar-search-expandable-block class="side-bar-body-item-custom-fields"
        [title]="'sidebar.search.body.customFields.title' | translate">
        <div class="side-bar-body-item-session-range">
          <fw-text-input size="small" [formControlName]="controlsEnum.CustomField" [cdkMenuTriggerFor]="customFieldMenu"
            [cdkMenuPosition]='customMenuPositions'
            [placeholder]="'sidebar.search.body.customFields.placeholder' | translate" class="side-bar-body-item-input">
          </fw-text-input>
          <ng-template #customFieldMenu>
            <ng-container *ngIf="(customFieldOptions$ | async) as customFieldOptions">
              <fw-menu-container *ngIf="customFieldOptions.length" width="175px" maxHeight="200px"
                style='overflow: hidden'>
                <fw-menu size="compact" (change)="selectCustomFieldOptions($any($event), customFieldOptions)">
                  <fw-menu-item size="compact" *ngFor="let menuItem of customFieldOptions" [title]="menuItem.name"
                    [value]="menuItem.name">
                  </fw-menu-item>
                </fw-menu>
              </fw-menu-container>
            </ng-container>
          </ng-template>
          <ng-container [formArrayName]="controlsEnum.CustomFieldsList">
            <div class="side-bar-body-item-custom-fields-item side-bar-body-item-offset"
              *ngFor="let selectedCustomField of customFields.controls; let i = index" [formGroupName]="i">
              <fw-chip [title]="selectedCustomField.value[customControllerFields.Name]"></fw-chip>
              <div [ngSwitch]="selectedCustomField.value[customControllerFields.Type]">
                <fw-text-input size="small" class="side-bar-body-item-custom-field"
                  *ngSwitchCase="fieldType.String" [formControlName]="customControllerFields.Value">
                </fw-text-input>
                <ng-template #customFieldItemMenu>
                  <fw-menu-container width="175px" maxHeight="200px" style='overflow: hidden'>
                    <fw-menu size="compact" (change)="selectCustomFieldItemOptions($any($event), selectedCustomField)">
                      <fw-menu-item size="compact"
                        *ngFor="let menuItem of typeahead[selectedCustomField.value[customControllerFields.Name]]"
                        [title]="menuItem" [value]="menuItem">
                      </fw-menu-item>
                    </fw-menu>
                  </fw-menu-container>
                </ng-template>
                <fw-radio-group size="compact" *ngSwitchCase="fieldType.Boolean"
                  [formControlName]="customControllerFields.Value"
                  [value]="selectedCustomField.value[customControllerFields.Value].value">
                  <fw-radio-button size="compact"
                    [title]="'sidebar.search.body.customFields.subfields.true' | translate"
                    [value]="customFieldBooleanTrue"></fw-radio-button>
                  <fw-radio-button size="compact"
                    [title]="'sidebar.search.body.customFields.subfields.false' | translate"
                    [value]="customFieldBooleanFalse"></fw-radio-button>
                </fw-radio-group>
                <div *ngSwitchCase="fieldType.Date" class="side-bar-body-item-custom-fields-range">
                  <fw-date-input size="small" [formControlName]="customControllerFields.Min"
                    type="date"></fw-date-input>
                  <fw-date-input size="small" [formControlName]="customControllerFields.Max"
                    type="date"></fw-date-input>
                </div>
                <div *ngSwitchCase="fieldType.Integer" class="side-bar-body-item-custom-fields-range">
                  <fw-text-input size="small" [formControlName]="customControllerFields.Min"
                    (change)="formatIntegerValue(selectedCustomField, customControllerFields.Min)"
                    [placeholder]="'sidebar.search.body.customFields.subfields.from' | translate"
                    type="number"></fw-text-input>
                  <fw-text-input size="small" [formControlName]="customControllerFields.Max"
                    (change)="formatIntegerValue(selectedCustomField, customControllerFields.Max)"
                    [placeholder]="'sidebar.search.body.customFields.subfields.to' | translate"
                    type="number"></fw-text-input>
                </div>
                <div *ngSwitchCase="fieldType.Float" class="side-bar-body-item-custom-fields-range">
                  <fw-text-input size="small" [formControlName]="customControllerFields.Min"
                    [placeholder]="'sidebar.search.body.customFields.subfields.from' | translate"
                    type="number"></fw-text-input>
                  <fw-text-input size="small" [formControlName]="customControllerFields.Max"
                    [placeholder]="'sidebar.search.body.customFields.subfields.to' | translate"
                    type="number"></fw-text-input>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </app-side-bar-search-expandable-block>
    </div>
  </div>
  <div class="side-bar-footer action" (click)="resetFilters()">
    <div class="action-title">
      <fw-icon color="primary" size="small">arrow-rotate-restore</fw-icon>
      <span>{{'sidebar.search.footer' | translate}}</span>
    </div>
  </div>
</form>
